import React from 'react';
import { withMarketingData } from '@core-ui/marketing-provider';
import { withBreakpointData, XLARGE } from '@core-ui/breakpoint-provider';
import { withBrandData } from '@core-ui/brand-info-provider';
import { propTypes } from './types';
import { FallbackHeader } from './fallback-header';

const hasSVGOverlayData = marketingData => marketingData
  && marketingData.data
  && marketingData.data.background;
const marketingDataIncludes = (marketingData, imgName) => marketingData.data.background.content
  && marketingData.data.background.content[imgName];
const shouldShowBasicSVGBillboard = (greaterOrEqualTo, marketingData) => (greaterOrEqualTo(XLARGE)
  ? marketingDataIncludes(marketingData, 'largeImg')
  : marketingDataIncludes(marketingData, 'smallImg'));
const CATEGORY_BANNERS = 'category-banners';

const isPositionTop = position => position === 'top';

const shouldShowMarketingHeader = (greaterOrEqualTo, marketingData) => (
  hasSVGOverlayData(marketingData)
    ? shouldShowBasicSVGBillboard(greaterOrEqualTo, marketingData)
    : marketingData
);

const isCategoryNotExcluded = (divisionMarketingData, did, cid) => divisionMarketingData
  && divisionMarketingData[did]
  && divisionMarketingData[did][CATEGORY_BANNERS]
  && (divisionMarketingData[did][CATEGORY_BANNERS].excludedCids
  && !divisionMarketingData[did][CATEGORY_BANNERS].excludedCids.includes(cid));

const shouldShowMarketingBanner = (marketingData, position) => marketingData
  && marketingData.data
  && marketingData.data.components
  && marketingData.data.components[position];



export const shouldHideTitleText = (hasRailMobileFacets, breadcrumbs) => {
  const hasCategoryName = !!breadcrumbs?.category?.name;
  const hasHiddenTitle = hasRailMobileFacets && hasCategoryName;
  return hasHiddenTitle;
};

const CategoryBanner = ({
  categoryName,
  criticalCss,
  hasHiddenTitle,
  position,
  selectedNodes = [],
  divisionMarketingData,
  brandData: {
    abbrBrand,
  },
  breakpointData: {
    greaterOrEqualTo,
    smallerThan,
  },
  marketingData: {
    pageSpecificMarketingData: marketingData,
    PageMarketing,
  },
}) => {
  const { id: did } = selectedNodes.find(({ type }) => type === 'division' || type === 'sub-division') || {};
  const { id: cid } = selectedNodes.find(({ type }) => type === 'category') || {};

  let mktingData = marketingData;
  let componentData;
  if (marketingData && marketingData.name === 'MarketingBanner') {
    componentData = marketingData
    && marketingData.data
    && marketingData.data.components
    && marketingData.data.components[position];
  } else if (position === 'top') {
    componentData = marketingData;
  }

  if (!componentData
      && isCategoryNotExcluded(divisionMarketingData, did, cid)) {
    mktingData = divisionMarketingData[did][CATEGORY_BANNERS];
    componentData = divisionMarketingData[did][CATEGORY_BANNERS].data.components[position];
  }

  const fallbackHeader = (
    <FallbackHeader
      position={position}
      shouldHideTitle={hasHiddenTitle && smallerThan(XLARGE)}
      categoryName={categoryName}
    />
  )

  if ((shouldShowMarketingHeader(greaterOrEqualTo, mktingData) && isPositionTop(position))
      || shouldShowMarketingBanner(mktingData, position)) {
    return (
      <PageMarketing
        {...mktingData}
        brandName={abbrBrand}
        componentData={componentData}
        criticalCss={criticalCss}
        fallbackContent={fallbackHeader}
        mktingType={CATEGORY_BANNERS}
        position={position}
      />
    );
  }
  return fallbackHeader;
};

CategoryBanner.propTypes = propTypes;

export { CategoryBanner as RawCategoryBanner };

export default withBreakpointData(withBrandData(withMarketingData(CategoryBanner)));
